import { useState, useCallback } from 'react';
import OverSizeService from './overSizeService';

const useOverSizeList = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [overSizeLists, setOverSizeLists] = useState([]);

  const fetchOverSizeLists = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await OverSizeService.getOverSizeLists();
      console.log(response.data.data)
      setOverSizeLists(response.data.data);
    } catch (err) {
      setError(err.message || 'Failed to fetch over size lists');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const registerOverSizeList = async (data) => {
    try {
      setLoading(true);
      setError(null);
      await OverSizeService.registerOverSizeList(data);
      // Fetch updated list after successful registration
      await fetchOverSizeLists();
    } catch (err) {
      setError(err.message || 'Failed to register over size list');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteOverSizeList = async (id) => {
    try {
      setLoading(true);
      setError(null);
      await OverSizeService.deleteOverSizeList(id);
      // Fetch updated list after successful deletion
      await fetchOverSizeLists();
    } catch (err) {
      setError(err.message || 'Failed to delete over size list');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    overSizeLists,
    registerOverSizeList,
    deleteOverSizeList,
    fetchOverSizeLists,
  };
};

export default useOverSizeList;
